module.exports = "pegasus/assets/empty/header-image.jpg";